export const EMPTY_TILE_ID = '__EMPTY_TILE__';
export const GRID_BORDER_ID = '__GRID_BORDER__';
export const GRID_BORDER_SIDE_NAME = 'b';
export const ERROR_TILE_ID = '__ERROR_TILE__';
export const UNRESOLVED_TILE_ID = '__UNRESOLVED_TILE__';
export const EMPTY_SIDE_NAME = 'empty';
